import * as React from 'react';
import { TooltipDesktop, UIText2 } from '@cian/ui-kit';
import { DiscountMortgageLabel } from './DiscountMortgageLabel';

import * as styles from './styles.css';

export function DiscountMortgageTooltip() {
  return (
    <TooltipDesktop
      title={
        <div className={styles['tooltip']}>
          <UIText2 color="text-inverted-default">
            Подробнее узнавайте <br /> у застройщика
          </UIText2>
        </div>
      }
      theme="black"
    >
      <DiscountMortgageLabel />
    </TooltipDesktop>
  );
}
